import { render, staticRenderFns } from "./pageview-store-detail-coach-rank.vue?vue&type=template&id=f1484450&scoped=true&"
import script from "./pageview-store-detail-coach-rank.vue?vue&type=script&lang=js&"
export * from "./pageview-store-detail-coach-rank.vue?vue&type=script&lang=js&"
import style0 from "./pageview-store-detail-coach-rank.vue?vue&type=style&index=0&id=f1484450&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f1484450",
  null
  
)

export default component.exports